<div class="form-checkbox-list overflow-y-auto" [ngClass]="{ 'check-box-scroll-hidden': !enableScroll }">
	<label *ngIf="checkBoxAll" class="pl-2">
		<input
			type="checkbox"
			class="custom-checkbox"
			[checked]="isCheckAll()"
			(change)="selectAll()"
			name="allcompanies"
		/>
		<span [ngClass]="{ 'fw-bold': boldSelectAll}">{{ allPhase }}</span>
	</label>
	<div *ngFor="let subArea of subAreasOptions">
		<div *ngIf="(hideSelected && !subArea.checked) || !hideSelected">
			<div *ngIf="(onlySelected && subArea.checked) || !onlySelected">
				<label>
					<input
						*ngIf="!subArea.separator && !onlyView"
						type="checkbox"
						[(ngModel)]="subArea.checked"
						(change)="selectOne(subArea)"
					/>
					<span class="custom-checkbox-separator" *ngIf="!subArea.separator">{{ label(subArea) }}</span>
				</label>
			</div>
		</div>
	</div>
</div>
